import React from 'react';
import styled from 'styled-components';
import {BrowserRouter as Router} from "react-router-dom";
import './App.css';
import CountDownTimer from "./components/CountDownTimer";
import People from "./components/People";
import {DesktopLogo, MobileLogo} from "./components/Logo";
import LogoText from "./components/LogoText";
import {analytics} from "firebase";
import "firebase/analytics";
import './initFirebase';
import {
    FacebookIcon,
    FacebookShareButton,
    OKIcon,
    OKShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    ViberIcon,
    ViberShareButton,
    VKIcon,
    VKShareButton,
} from "react-share";
import HelmetMetaData from "./components/MetaData";
import useScreenSize from "./utils/useScreenSize";
import WhoBlock from "./blocks/WhoBlock";
import HowBlock from "./blocks/HowBlock";
import WhyBlock from "./blocks/WhyBlock";
import WhatBlock from "./blocks/WhatBlock";
import WhyImportantBlock from "./blocks/WhyImportantBlock";
import LinksBlock from "./blocks/LinksBlock";
import MapBlock from "./blocks/MapBlock";
import Initiative from "./blocks/Initiative";

const TimerWrapper = styled.div`
  position: absolute;
  top: 8vw;
  left: 47vw;
`
const ShareWrapper = styled.div`

`
const DistributiveWrapper = styled.div`
  display: flex;
  
  @media only screen and (max-width: 600px) {
     flex-direction: column;
  }
  
  h2{
  margin: 0;
  padding: 0;
  }
  //justify-content: center;
  //align-items: center;
`
const DistributiveMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`

const PeopleWrapper = styled.div`
  position: absolute;
  top: 43vw;
   @media only screen and (max-width: 600px) {
     top: 65vw;
  }
  right: 0vw;
`

const HeaderWrapper = styled.div`
  background: #CB1700;
  padding: 10px 25%;
  h1{
    color: white;
    font-size: 3rem;
    position: relative;
    z-index: 2;
  }
  h2{
    color: white;
    font-size: 2rem
  }
  
  @media only screen and (max-width: 600px) {
      padding: 10px 5%;
      h1{
        color: white;
        font-size: 8vw;
        width: 100%;
        text-align: center;
      }
  }
  
  p{
    font-size: 1rem;
  }
`

const ContentWrapper = styled.div`
   padding: 100px 25%;
   @media only screen and (max-width: 600px) {
      padding: 50px 5%;
   }
  
 
  
  .f{
    display: flex;
  }
  
  .f1{
    flex: 1
  }
  .f2{
    flex: 2
  }
  .f3{
    flex: 3
  }
  .red{
    background: red;
  }
  .blue{
    background: blue;
  }
  .green{
     background: green;
  }
  
  .ac{
    align-items: center;
  }
  .as{
    align-items: flex-start;
  }
  
  .jc{
    justify-content: center;
  }
  .js{
    justify-content: flex-start;
  }

  ol{
      padding: 0 0 0 1.3rem;
  }
   li{
      font-size: 1.2rem;
      font-weight: bold;
      padding: 0;
      margin: 0;
   }
   h1{
   color: #CB1700;
    width: 100%;
        text-align: center;
        text-transform: uppercase;
        font-size: 7vw;
   }
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  //padding: 10px 25%;
  @media only screen and (max-width: 600px) {
      padding: 10px 5%;
  }
  padding-bottom: 10vw;
`

const ShadowWrapper = styled.a`
  overflow: hidden;
  border-radius: 1vw;
  width: 80%;
  margin: 0;
  padding: 0;
   @media only screen and (max-width: 600px) {
      border-radius: 5.5vw;
       width: auto;
      
  }
  -webkit-box-shadow: 0px 13px 22px -12px rgba(0,0,0,0.41);
  -moz-box-shadow: 0px 13px 22px -12px rgba(0,0,0,0.41);
  box-shadow: 0px 13px 22px -12px rgba(0,0,0,0.41);
`

const Button = styled.a`
    text-decoration: none;
     background: #CB1700;
   color: white;
   border-radius: 1vw;
    -webkit-box-shadow: 0px 13px 22px -12px rgba(0,0,0,0.41);
    -moz-box-shadow: 0px 13px 22px -12px rgba(0,0,0,0.41);
    box-shadow: 0px 13px 22px -12px rgba(0,0,0,0.41);
      padding: 20px 30px;
       text-align: center;
     @media only screen and (max-width: 600px) {
      border-radius: 5.5vw;
       width: auto;
  }
   span{
 
   text-decoration: none;
   font-size: 1.4em;
  

   }
`
const ButtonWrapper = styled.div`
   padding: 70px 0px;
   display: flex;
   justify-content: center;
`

const createShareEvent = (social) => () => {
    analytics().logEvent('share', {social});
}

const createDownloadEvent = (item) => () => {
    analytics().logEvent('downloadItem', {item});
}

const DesktopView = () => (
    <div className="App">
        <DesktopLogo/>
        <TimerWrapper>
            <LogoText width={'35vw'}/>
            {/*<CountDownTimer/>*/}
        </TimerWrapper>
        <PeopleWrapper>
            <People height={'15vw'}/>
        </PeopleWrapper>
        <HeaderWrapper>
            <h1>Срок Народного Ультиматума истек!
                Мы начинаем общенациональную забастовку.
            </h1>

        </HeaderWrapper>
        <ContentWrapper>
            <h2>Наши требования:</h2>
            <ol >
                <li>Требуем Лукашенко заявить о своем уходе</li>
                <li>Требуем остановить насилие полностью</li>
                <li>Требуем освободить всех политзаключенных</li>
            </ol>
            <div style={{display: "flex"}}>
                <h3 style={{"padding-right": "20px"}}>Расскажи друзьям:</h3>
                <ShareWrapper >
                    <HelmetMetaData
                        quote={''}
                        title={"25 октября - народный ультиматум"}
                        image={"/logo.png"}
                        description={"Ультиматум до 25 октября\n" +
                        "1. Требуем Лукашенко заявить о своем уходе\n" +
                        "2. Требуем остановить насилие полностью\n" +
                        "3. Требуем освободить всех политзаключенных\n"}
                        hashtag={'#народныйультиматум'}
                    />
                    <TelegramShareButton
                        url={"https://ultimatum2020.org/"}
                        quote={
                            "Ультиматум до 25 октября\n" +
                            "1. Требуем Лукашенко заявить о своем уходе\n" +
                            "2. Требуем остановить насилие полностью\n" +
                            "3. Требуем освободить всех политзаключенных\n"}
                        hashtag="#народныйультиматум">

                        <TelegramIcon size={36}/>
                    </TelegramShareButton>
                    <FacebookShareButton
                        url={"https://ultimatum2020.org/"}
                        quote={
                            "Ультиматум до 25 октября\n" +
                            "1. Требуем Лукашенко заявить о своем уходе\n" +
                            "2. Требуем остановить насилие полностью\n" +
                            "3. Требуем освободить всех политзаключенных\n"}
                        hashtag="#народныйультиматум">

                        <FacebookIcon size={36}/>
                    </FacebookShareButton>
                    <OKShareButton
                        url={"https://ultimatum2020.org/"}
                        quote={
                            "Ультиматум до 25 октября\n" +
                            "1. Требуем Лукашенко заявить о своем уходе\n" +
                            "2. Требуем остановить насилие полностью\n" +
                            "3. Требуем освободить всех политзаключенных\n"}
                        hashtag="#народныйультиматум">

                        <OKIcon size={36}/>
                    </OKShareButton>
                    <VKShareButton
                        url={"https://ultimatum2020.org/"}
                        quote={
                            "Ультиматум до 25 октября\n" +
                            "1. Требуем Лукашенко заявить о своем уходе\n" +
                            "2. Требуем остановить насилие полностью\n" +
                            "3. Требуем освободить всех политзаключенных\n"}
                        hashtag="#народныйультиматум">

                        <VKIcon size={36}/>
                    </VKShareButton>
                    <TwitterShareButton
                        url={"https://ultimatum2020.org/"}
                        quote={
                            "Ультиматум до 25 октября\n" +
                            "1. Требуем Лукашенко заявить о своем уходе\n" +
                            "2. Требуем остановить насилие полностью\n" +
                            "3. Требуем освободить всех политзаключенных\n"}
                        hashtag="#народныйультиматум">

                        <TwitterIcon size={36}/>
                    </TwitterShareButton>
                    <ViberShareButton
                        url={"https://ultimatum2020.org/"}
                        quote={
                            "Ультиматум до 25 октября\n" +
                            "1. Требуем Лукашенко заявить о своем уходе\n" +
                            "2. Требуем остановить насилие полностью\n" +
                            "3. Требуем освободить всех политзаключенных\n"}
                        hashtag="#народныйультиматум">
                        <ViberIcon size={36}/>
                    </ViberShareButton>
                </ShareWrapper>
            </div>

        </ContentWrapper>
            <Blocks/>

    </div>
)


const Blocks = () => {
    return (
        <>
            {/*<MapBlock/>*/}
            <Initiative/>
            <WhoBlock />
            <WhatBlock/>
            <HowBlock/>
            <WhyImportantBlock/>
            <WhyBlock/>
            <LinksBlock/>
        </>
    )
}


const MobileView = () => (
    <div className="App">
        <MobileLogo/>
        <TimerWrapper>

        </TimerWrapper>
        <PeopleWrapper>
            <People height={'25vw'}/>
        </PeopleWrapper>
        <HeaderWrapper>
            <h1>Срок Народного Ультиматума истек!
                Мы начинаем общенациональную забастовку.
            </h1>
        </HeaderWrapper>
        {/*<CountDownTimer/>*/}
        <ContentWrapper>
            <h1>Наши требования:</h1>
            <ol>
                <li>Требуем Лукашенко заявить о своем уходе</li>
                <li>Требуем остановить насилие полностью</li>
                <li>Требуем освободить всех политзаключенных</li>
            </ol>
            <h4>Расскажи друзьям:</h4>
            <ShareWrapper>
                <HelmetMetaData
                    quote={''}
                    title={"25 октября - народный ультиматум"}
                    image={"/logo.png"}
                    description={"Ультиматум до 25 октября\n" +
                    "1. Требуем Лукашенко заявить о своем уходе\n" +
                    "2. Требуем остановить насилие полностью\n" +
                    "3. Требуем освободить всех политзаключенных\n"}
                    hashtag={'#народныйультиматум'}
                />
                <TelegramShareButton
                    beforeOnClick={createShareEvent('telegram')}
                    url={"https://ultimatum2020.org/"}
                    quote={
                        "Ультиматум до 25 октября\n" +
                        "1. Требуем Лукашенко заявить о своем уходе\n" +
                        "2. Требуем остановить насилие полностью\n" +
                        "3. Требуем освободить всех политзаключенных\n"}
                    hashtag="#народныйультиматум">

                    <TelegramIcon size={36}/>
                </TelegramShareButton>
                <FacebookShareButton
                    url={"https://ultimatum2020.org/"}
                    beforeOnClick={createShareEvent('facebook')}
                    quote={
                        "Ультиматум до 25 октября\n" +
                        "1. Требуем Лукашенко заявить о своем уходе\n" +
                        "2. Требуем остановить насилие полностью\n" +
                        "3. Требуем освободить всех политзаключенных\n"}
                    hashtag="#народныйультиматум">

                    <FacebookIcon size={36}/>
                </FacebookShareButton>
                <OKShareButton
                    url={"https://ultimatum2020.org/"}
                    beforeOnClick={createShareEvent('ok')}
                    quote={
                        "Ультиматум до 25 октября\n" +
                        "1. Требуем Лукашенко заявить о своем уходе\n" +
                        "2. Требуем остановить насилие полностью\n" +
                        "3. Требуем освободить всех политзаключенных\n"}
                    hashtag="#народныйультиматум">

                    <OKIcon size={36}/>
                </OKShareButton>
                <VKShareButton
                    url={"https://ultimatum2020.org/"}
                    beforeOnClick={createShareEvent('vk')}
                    quote={
                        "Ультиматум до 25 октября\n" +
                        "1. Требуем Лукашенко заявить о своем уходе\n" +
                        "2. Требуем остановить насилие полностью\n" +
                        "3. Требуем освободить всех политзаключенных\n"}
                    hashtag="#народныйультиматум">

                    <VKIcon size={36}/>
                </VKShareButton>
                <TwitterShareButton
                    url={"https://ultimatum2020.org/"}
                    beforeOnClick={createShareEvent('twitter')}
                    quote={
                        "Ультиматум до 25 октября\n" +
                        "1. Требуем Лукашенко заявить о своем уходе\n" +
                        "2. Требуем остановить насилие полностью\n" +
                        "3. Требуем освободить всех политзаключенных\n"}
                    hashtag="#народныйультиматум">

                    <TwitterIcon size={36}/>
                </TwitterShareButton>
                <ViberShareButton
                    url={"https://ultimatum2020.org/"}
                    beforeOnClick={createShareEvent('viber')}
                    quote={
                        "Ультиматум до 25 октября\n" +
                        "1. Требуем Лукашенко заявить о своем уходе\n" +
                        "2. Требуем остановить насилие полностью\n" +
                        "3. Требуем освободить всех политзаключенных\n"}
                    hashtag="#народныйультиматум">

                    <ViberIcon size={36}/>
                </ViberShareButton>

            </ShareWrapper>

        </ContentWrapper>
        <Blocks/>
    </div>
)

function App() {
    const {width} = useScreenSize();
    const isMobile = width <= 600;
    return (
        <Router>
            {isMobile ? <MobileView/> : <DesktopView/>}
        </Router>

    );
}

export default App;
